import { Box, Typography } from "@mui/material";
import {
    Bar,
    BarChart,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    Cell,
    LabelList,
} from "recharts";
import { ChartTooltip, COLORS } from "../../../../ui/Theme";
import { ListDivider } from "../../../../ui/ListStyles";

const CustomTooltip = ({ active, payload, y_title }) => {
    if (active && payload && payload.length) {
        const { x, y } = payload[0].payload;
        return (
            <ChartTooltip sx={{ bgcolor: COLORS.SOFTBLUE }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 900, direction: "rtl" }}>
                    {x}
                </Typography>
                <ListDivider />
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        color: COLORS.BLUE,
                    }}
                >
                    <Typography sx={{ fontSize: "12px" }}>{y_title} : </Typography>
                    <Typography sx={{ fontSize: "12px", fontWeight: 900, direction: "rtl" }}>
                        {y}
                    </Typography>
                </Box>
            </ChartTooltip>
        );
    }
    return null;
};

const PercentRangesChart = ({ data }) => {
    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={data.history}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
                <XAxis textAnchor="middle" dataKey="x" />
                <Tooltip content={<CustomTooltip y_title={data.y_title} />} cursor={{ fill: COLORS.SOFTGRAY }} />
                <Legend
                    wrapperStyle={{
                        width: "fit-content",
                        top: -10,
                        right: 0,
                        lineHeight: "20px",
                    }}
                    verticalAlign="top"
                    formatter={(value) =>
                        value === "y" ? (
                            <span style={{ marginRight: "5px" }}>{data.chart_title}</span>
                        ) : (
                            <span style={{ marginRight: "5px" }}>{value}</span>
                        )
                    }
                />
                <Bar dataKey="y">
                    {data.history.map((entry, index) => {
                        const isNegative = entry.x.includes("٪-");
                        const fillColor = isNegative ? "#f44336" : "#4caf50";
                        return <Cell key={`cell-${index}`} fill={fillColor} />;
                    })}
                    <LabelList dataKey="y" position="top" />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default PercentRangesChart;
